import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const PlacementsLeftTab = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
    return (
        <div className="additional-information">
            <div className="list">
                <ul>
                    <Link to="/training-and-placements" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> About TPD
                        </li>
                    </Link>
                    <Link
                        to="/training-and-placements/skill-enhancement"
                        
                    >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Skill Enhancement
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2024-25" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2024-25
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2023-24" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2023-24
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2022-23" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2022-23
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2021-22" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2021-22
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2020-21" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2020-21
                        </li>
                    </Link>
                    {/* <Link to="/training-and-placements/2019-20" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2019-20
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2018-19" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2018-19{" "}
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2017-18" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2017-18{" "}
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2016-17" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2016-17
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2015-16" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2015-16{" "}
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2014-15" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2014-15{" "}
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2013-14" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2013-14{" "}
                        </li>
                    </Link>
                    <Link to="/training-and-placements/2012-13" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Placements 2012-13{" "}
                        </li>
                    </Link> */}
                    {/* <Link to="" ><li className='text-black'><i class="fa fa-university"></i> Placements 2005-12 </li></Link> */}
                    {/* <Link
                        to="/training-and-placements/technical-training"
                        
                    >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Technical Training
                        </li>
                    </Link> */}
                    {/* <Link
                        to="/training-and-placements/dept-wise-placements"
                        
                    >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Dept Wise Placements
                        </li>
                    </Link> */}

                    <Link to="/dept/cse/placements" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> CSE
                        </li>
                    </Link>
                    <Link to="/dept/ece/placements" >
                        <li className="text-black">
                            <i class="fa fa-university"></i>
                            ECE
                        </li>
                    </Link>
                    <Link to="/dept/it/placements" >
                        <li className="text-black">
                            <i class="fa fa-university"></i>
                            IT
                        </li>
                    </Link>
                    <Link to="/training-and-placements/task" >
                        <li className="text-black">
                            <i class="fa fa-university"></i> Task{" "}
                        </li>
                    </Link>
                </ul>
            </div>
        </div>
    );
};

export default PlacementsLeftTab;
